import { makePersisted } from '@solid-primitives/storage'
import { createRoot } from 'solid-js'
import { createStore } from 'solid-js/store'

const getAppHash = (): string => {
  if (typeof window !== 'undefined' && window.__APP_HASH__) {
    return window.__APP_HASH__
  }
  return 'app'
}

const getAppDarkColor = (): string => {
  if (typeof window !== 'undefined' && window.__APP_DARK_COLOR__) {
    return window.__APP_DARK_COLOR__
  }
  return ''
}

const getAppColor = (): string => {
  if (typeof window !== 'undefined' && window.__APP_COLOR__) {
    return window.__APP_COLOR__
  }
  return ''
}

if (typeof window !== 'undefined') {
  if (!window.__APP_HASH__) {
    window.__APP_HASH__ = getAppHash()
  }
  if (!window.__APP_DARK_COLOR__) {
    window.__APP_DARK_COLOR__ = getAppDarkColor()
  }
  if (!window.__APP_COLOR__) {
    window.__APP_COLOR__ = getAppColor()
  }
}

interface Settings {
  theme: 'light' | 'dark'
}

const defaultSettings: Settings = {
  theme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

const [settings, setSettings] = createRoot(() =>
  makePersisted(createStore<Settings>(defaultSettings), {
    name: `${getAppHash()}-app-settings`,
    storage: localStorage
  })
)

export const useSettings = () => {
  const updateTheme = (theme: 'light' | 'dark') => {
    setSettings({ theme })
    const el = document.documentElement
    // Desactiva las transiciones durante el swap para que TODO cambie en el mismo frame
    // (si no, cada elemento anima su color a su propia duración y se nota escalonado).
    el.classList.add('theme-switching')
    el.setAttribute('data-theme', theme)
    el.classList.toggle('dark', theme === 'dark')

    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? getAppDarkColor() : getAppColor())

    // Fuerza reflow para aplicar el cambio de golpe y restaura transiciones tras dos frames.
    void el.offsetWidth
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove('theme-switching')))
  }

  return {
    settings,
    updateTheme
  }
}
